// import DOMPurify from 'dompurify';
import React, { FC, useEffect, useState } from 'react';
import Marquee from 'react-fast-marquee';
import { useTranslation } from 'react-i18next';
import { ReactComponent as Globe } from '../../../../../assets/icons/sas-globe.svg';
import {
    ImageContainer,
    IntroImageXs,
    MarqueeBg,
    MarqueeContainer,
    MarqueeDayContainer,
    MarqueeDayLabel,
    MarqueeItem,
} from './styled';

const MarqueeItemComponent: FC = () => {
    const { t } = useTranslation('pages/home');
    const [days, setDays] = useState<number>(0);
    const [hours, setHours] = useState<number>(0);
    const [minutes, setMinutes] = useState<number>(0);
    const [seconds, setSeconds] = useState<number>(0);

    const deadline = 'October, 20, 2026';

    const getTime = (deadline: string) => {
        const time = Date.parse(deadline) - Date.now();

        const days = Math.floor(time / (1000 * 60 * 60 * 24));
        const hours = Math.floor((time / (1000 * 60 * 60)) % 24);
        const minutes = Math.floor((time / 1000 / 60) % 60);
        const seconds = Math.floor((time / 1000) % 60);
        setDays(days < 0 ? 0 : days);
        setHours(hours < 0 ? 0 : hours);
        setMinutes(minutes < 0 ? 0 : minutes);
        setSeconds(seconds < 0 ? 0 : seconds);
    };

    useEffect(() => {
        const interval = setInterval(() => getTime(deadline), 1000);

        return () => clearInterval(interval);
    }, []);

    return (
        <MarqueeItem>
            <MarqueeDayContainer>
                {days}
                <MarqueeDayLabel>{t('days')}</MarqueeDayLabel>
            </MarqueeDayContainer>
            <MarqueeDayContainer>
                {hours}
                <MarqueeDayLabel>{t('hours')}</MarqueeDayLabel>
            </MarqueeDayContainer>
            <MarqueeDayContainer>
                {minutes}
                <MarqueeDayLabel>{t('minutes')}</MarqueeDayLabel>
            </MarqueeDayContainer>
            <MarqueeDayContainer>
                {seconds}
                <MarqueeDayLabel>{t('seconds')}</MarqueeDayLabel>
            </MarqueeDayContainer>
        </MarqueeItem>
    );
};

const HomeMarquee: FC = () => {
    const { t } = useTranslation('pages/home');

    return (
        <ImageContainer image={'/assets/images/sas.png'}>
            {/*<Title>
                {t('marquee-title-main')}
                <Year>{t('marquee-title-year')}</Year>
            </Title>}*/}
            <IntroImageXs src={'/assets/images/sas.png'} />
            <MarqueeContainer>
                <MarqueeBg />
                <Marquee direction="left" speed={50} gradient={false}>
                    <MarqueeItemComponent />
                    <Globe />
                    <MarqueeItemComponent />

                    <Globe />

                    <MarqueeItemComponent />

                    <Globe />
                    <MarqueeItemComponent />

                    <Globe />

                    <MarqueeItemComponent />

                    <Globe />

                    <MarqueeItemComponent />

                    <Globe />

                    <MarqueeItemComponent />

                    <Globe />
                </Marquee>
            </MarqueeContainer>
        </ImageContainer>
    );
};

export default HomeMarquee;
